/* eslint-disable import/first */
import React, { useState, useEffect, useContext } from 'react';
import Hreflang from '../../components/Hreflang';
import { Button, Grid, TextField, Box } from '@material-ui/core';
import {
  makeStyles,
  createMuiTheme,
  jssPreset,
  ThemeProvider,
  StylesProvider,
} from '@material-ui/core/styles';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch } = Redux;
import { FormattedMessage, useIntl } from 'react-intl';
const { selectCountryValidations } = Slices.configSlice;
const { getTrackingOrder, selectCurrentOrders } = Slices.orderSlice;
const { selectCurrentCountry } = Slices.profileSlice;
const { selectAllMain } = Slices.categorySlice;
import { useNavigate } from '@reach/router';
// import { MdErrorOutline } from '@react-icons/all-files/md/MdErrorOutline';
import { orderTrackGA } from 'spwa-ui-library/esm/utils/helperGA';
// import { MobileNumberInput } from '../Profile/MobileNumberInput';
import { create } from 'jss';
import Cookies from 'js-cookie';
import rtl from 'jss-rtl';
import css from './TrackOrderComponent.module.scss';
// import Loader from '../../components/Loader/index.jsx';
import { Context } from '../../components/Multi-lang/Wrapper';
import NoOrder from '../../components/NoOrder';
import noOrderTrack from './images/noordertrack.svg';
import CurrentOrder from '../../components/CurrentOrder';
import Loader from '../../components/Loader';

const placeholderStyle = {
  color: '#393F52',
  fontFamily: 'Rubik',
  fontStyle: 'normal',
  fontWeight: '500',
  fontSize: '1.4rem',
  lineHeight: '1.5rem',
  opacity: '0.4',
};

const useStyles = makeStyles({
  input: {
    bottom: '29.03%',
    fontFamily: 'Rubik',
    fontStyle: 'normal',
    fontWeight: '500 !important',
    fontSize: '1.4rem !important',
    lineHeight: '2.2rem',
    color: '#393F52',
    padding: '0.6rem 0 0.3rem',
  },
});

export const URLEncode = (inputSrc) => encodeURI(inputSrc?.toLowerCase().replace(/\s/g, '-'));

const TrackOrderComponent = () => {
  const [disable, setDisable] = useState(true);
  const [errorBool, setErrBool] = useState(false);
  const [msg, setMsg] = useState('');
  const intl = useIntl();
  const [mobile, setMobile] = useState('');
  const [orderId, setOrderId] = useState('');
  const [pageLoader, setPageLoader] = useState(false);
  const dispatch = useDispatch();
  const country = useSelector(selectCurrentCountry);
  const countryValidations = useSelector((state) => selectCountryValidations(state, country));
  const navigate = useNavigate();
  const classes = useStyles();
  const categories = useSelector(selectAllMain);
  const context = useContext(Context);
  const result = categories?.sort((a, b) => a.position - b.position);
  const exploreMenuPath = `/${context?.locale}/${URLEncode(result[0]?.name)}/${result[0]?.id}`;
  const orders = useSelector(selectCurrentOrders);

  const ltrTheme = createMuiTheme({ direction: 'ltr' });
  const rtlTheme = createMuiTheme({ direction: 'rtl' });
  const jss = create({ plugins: [...jssPreset().plugins, rtl()] });
  const [isRtl] = useState(Cookies.get('local') === 'ar' ? rtlTheme : ltrTheme);

  // const validationErros = useSelector(selectValidationErrorMsgs);
  // eslint:fix validationErros is defined a value but never used

  const handleMobileInput = (event) => {
    const val = event.target.value;

    setMobile(val);
  };
  // const mobileValidation = (inputtxt) => {
  //   var phoneno = countryValidations.phnRegex;
  //   if (inputtxt.match(phoneno)) {
  //     if (inputtxt.match(phoneno) && orderId.length > 0) {
  //       setDisable(false);
  //     }
  //     return true;
  //   } else {
  //     setDisable(true);
  //     // Fire an error here
  //     return false;
  //   }
  // };
  useEffect(() => {
    if (countryValidations && countryValidations.phnLength === mobile.length) {
      // mobileValidation(mobile);
      var phoneno = countryValidations.phnRegex;
      if (mobile.match(phoneno) && orderId.length > 0) {
        setDisable(false);
      } else {
        setDisable(true);
        // Fire an error here
      }
    }
  }, [countryValidations, mobile, orderId]);

  const changeOrder = (value) => {
    const regEx = /^[0-9a-z]+$/i;
    if (regEx.test(value)) {
      setOrderId(value);
    }
  };

  const handleSubmit = () => {
    setPageLoader(true);
    let payload = { phnNo: mobile, orderId: orderId, cCode: countryValidations.defaultCCode };
    // countryValidations.defaultCCode -- is the country code
    dispatch(getTrackingOrder(payload))
      .then((res) => {
        if (res.payload) {
          setPageLoader(false);
          if (
            res.payload.data.data.status === 'CANCELED' ||
            res.payload.data.data.status === 'FAILURE'
          ) {
            navigate(`/${intl.locale}/thank-you/${res.payload.data.data._id}`, { replace: true });
          } else {
            navigate(`/${intl.locale}/track-order/${res.payload.data.data._id}?modal=track`);
          }
          orderTrackGA(orderId, 'TrackOrderPage');
        } else {
          setErrBool(true);
          setMsg(res.error.message);
          // .split(']')[1]
        }
        setPageLoader(false);
      })
      .catch((err) => {
        setErrBool(true);
        setMsg(err.message);
      });
  };

  const onlyNumbers = (evt) => {
    var ASCIICode = evt.which ? evt.which : evt.keyCode;
    if (ASCIICode > 31 && (ASCIICode < 48 || ASCIICode > 57)) evt.preventDefault();
    return true;
  };

  const navigateToExplore = () => {
    navigate(exploreMenuPath);
  };

  if (pageLoader) {
    return <Loader />;
  }

  return (
    <>
      {orders?.length === 0 || !orders.length ? (
        <Grid className={css.noOrderWrapper}>
          <Hreflang page="trackOrder" />
          <NoOrder
            callback={navigateToExplore}
            heading={<FormattedMessage id="no_orders_track" defaultMessage="No Orders to Track" />}
            subHeading={
              <FormattedMessage
                id="no_orders_track_subHead"
                defaultMessage="For now, no active orders available"
              />
            }
            img={noOrderTrack}
          />
        </Grid>
      ) : (
        <CurrentOrder />
      )}
    </>
  );
};

export default TrackOrderComponent;
